import React from "react";
import styles from './index.module.css';

const Card = ({ icon, text, number }) => {
    return (
        <div className={`${styles.card} ${styles[text]}`}>
            <div className={styles.cardIcon}>
                {/* <FontAwesomeIcon icon={icon} className={styles.cardIconImage} /> */}
                <div className={styles.cardIconImage}>
                    {icon}
                </div>
            </div>
            <div className={styles.cardContent}>
                <p className={styles.cardText}>{text}</p>
                <h1 className={styles.cardNumber}>{number}</h1>
            </div>
        </div>
    );
};

export default Card;